import React, {Component} from 'react';
import styled from 'styled-components';
import QuoteMarks from '../../assets/img/quotes.svg';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import {Carousel} from 'react-responsive-carousel';

class SingleTestimonial extends Component {
	constructor(props) {
		super(props);
		this.wrapper = React.createRef();
	}

	render() {
		const {testimonial} = this.props;

		const TestimonialWrapper = styled.div`
			margin: 5em auto;
			position: relative;

			@media screen and (min-width: 640px) {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		`;

		const TestimonialTextWrapper = styled.div`
			@media screen and (min-width: 640px) {
				${testimonial.video && 'flex-basis: 65%;'}
				${testimonial.image && 'margin-right: 50px;'}
			}
		`;

		const TestimonialText = styled.h3`
			line-height: 1.5;
			text-align: left;
		`;

		const TestimonialMedia = styled.div`
			text-align: left;

			@media screen and (min-width: 640px) {
				max-width: 40%;
			}
		`;

		const TestimonialMediaCaption = styled.small`
			text-align: center;
			display: block;
			margin: 1.5em auto .8em;

			@media screen and (min-width: 640px) {
				// max-width: 70%;
			}
		`;

		const TestimonialUser = styled.div`
			text-align: left;
		`;

        const VideoLink = styled.a`
            color: #589494;
            display: block;
            text-align: center;
            font-weight: bold;

            &:after {
                content: '';
                background: url('/assets/icons/link.svg') no-repeat;
                background-size: cover;
                height: 23px;
                width: 23px;
                margin-left: 7px;
                margin-top: -5px;
                display: inline-block;
                vertical-align: middle;
            }
        `;

		const QuotationMarks = styled.img`
			width: auto !important;
			min-width: 50px;
			position: absolute;
			top: -80px;
			left: 0;
		`;

		const AuthorImage = styled.img`
			height: 300px;
			object-fit: cover;
			border-radius: 10px;

			@media screen and (min-width: 640px) {
				max-width: 300px;
				width: 40%;
			}
		`;

		return (
			<TestimonialWrapper>
				<QuotationMarks src={QuoteMarks} alt="Testimonial Quotes" />
				<TestimonialTextWrapper>
					<TestimonialText>{testimonial.testimonial}</TestimonialText>
					<TestimonialUser>
						<hr className="mini" />
						<p>{testimonial.name}</p>
						<small>{testimonial.location}</small>
					</TestimonialUser>
				</TestimonialTextWrapper>
				<TestimonialMedia>
					{testimonial.image && <AuthorImage src={testimonial.image} alt={testimonial.name} />}
					<TestimonialMediaCaption>{testimonial.caption}</TestimonialMediaCaption>
					{testimonial.hasVideo && <VideoLink target="_blank" href={testimonial.videoLink}>Watch Video</VideoLink>}
				</TestimonialMedia>
			</TestimonialWrapper>
		);
	}
}

export default SingleTestimonial;
